let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cbkj0"), load("9Oxgj"), load("4Afgd"), load("18TX5"), load("lp8Wm"), load("l2LZP")]).then(() => parcelRequire('9GSdj'));